'use client'

import { FormEvent, useState } from 'react'
import { registerNewUser } from '../lib/server-utils'
import { Spinner } from '@nextui-org/spinner'
import { getAuthErrorMessage } from '../lib/utils'

export default function RegisterForm() {
    const [checking, setChecking] = useState(false)

    async function register(event: FormEvent<HTMLFormElement>) {
        event.preventDefault()
        setChecking(true)

        const formData = new FormData(event.currentTarget)
        const name = formData.get('name')?.toString() ?? ''
        const email = formData.get('email')?.toString() ?? ''
        const password = formData.get('password')?.toString() ?? ''
        const cpassword = formData.get('confirm-password')?.toString() ?? ''

        if (cpassword != password) {
            alert('Attenzione: le password non corrispondono.')
            setChecking(false)
            return
        }

        try {
            await registerNewUser(email, password, name)
        } catch (error: any) {
            alert(getAuthErrorMessage(error.code))
            setChecking(false)
            return
        }

        setChecking(false)
        window.location.href = '/access/login'
    }

    return (
        <form
            onSubmit={register}
            className="grid w-full grid-cols-1 justify-center bg-black"
        >
            <div className="grid w-full grid-cols-1 justify-items-center gap-y-4 text-lg lg:grid-cols-2 lg:grid-rows-2">
                <input
                    id="name"
                    type="text"
                    name="name"
                    className="form-input order-2"
                    placeholder="Nome/Username"
                    required
                />
                <input
                    id="email"
                    type="email"
                    name="email"
                    className="form-input order-2 lg:order-3"
                    placeholder="Email"
                    required
                />
                <input
                    id="password"
                    type="password"
                    name="password"
                    className="form-input order-3 lg:order-2"
                    placeholder="Password"
                    required
                />
                <input
                    id="confirm-password"
                    type="password"
                    name="confirm-password"
                    className="form-input order-4"
                    placeholder="Conferma Password"
                    required
                />
            </div>
            <div className="my-8 flex w-full items-center justify-center justify-self-center md:w-80 lg:w-80">
                <button className="mobile-button-green">
                    {!checking && 'REGISTRATI'}
                    {checking && <Spinner color="primary" />}
                </button>
            </div>
            <div className="grid w-full grid-cols-1 justify-self-center bg-black px-4 text-sm text-white lg:w-[630px]">
                <p>Disclaimer:</p>
                <p className="italic">
                    Il tuo account e i dati inseriti per le prenotazioni di
                    sessioni ed eventi verranno cancellati dopo 10/15 giorni dal
                    termine del ToPlay.{' '}
                </p>
                <p className="italic">
                    Al termine della manifestazione nessuna informazione rimarrà
                    sulla banca dati dell'associazione "Il Fortuna Dado". I dati
                    raccolti verranno utilizzati solo durante i giorni del
                    festival "ToPlay" e in alcun modo verranno rilasciati a
                    terzi.{' '}
                </p>
            </div>
            {/** TODO: inserire l'errore come popup/toast/elemento custom, e rimuovere gli alert */}
        </form>
    )
}
